const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: document.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    target.setAttribute(attributes.expanded, (target.getAttribute(attributes.expanded) === 'false').toString());
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}




function filterGallery() {
  const syncTagsInput = document.querySelector('input[name="properties[_syncTags]"]');
  if (!syncTagsInput) return;

  const selectedTag = syncTagsInput.value; // z.B. "Blau (dunkel)**Dino"
  const selectedColor = selectedTag.split('**')[0]; // z.B. "Blau (dunkel)"

  // Große Bilder filtern
  document.querySelectorAll('.product__media-list .slider__slide').forEach(slide => {
    const alt = slide.querySelector('img')?.alt || '';
    const show = alt === 'general' || alt === selectedTag || alt === selectedColor;
    slide.style.setProperty('display', show ? '' : 'none', 'important');
  });

  // Thumbnails filtern
  document.querySelectorAll('li.thumbnail-list__item').forEach(item => {
    const alt = item.querySelector('img')?.alt || '';
    const show = alt === 'general' || alt === selectedTag || alt === selectedColor;
    item.style.setProperty('display', show ? '' : 'none', 'important');
  });
  // Ersten sichtbaren Thumbnail automatisch anklicken
  setTimeout(() => {
  const firstVisible = Array.from(document.querySelectorAll('li.thumbnail-list__item'))
    .find(item => getComputedStyle(item).display !== 'none');
  firstVisible?.querySelector('button, a')?.click();
  }, 70);

}

// Bei Änderung der Auswahl filtern
function initBildfilter() {
  filterGallery();

  document.addEventListener('change', (e) => {
    if (e.target.name?.includes('properties[')) {
      setTimeout(filterGallery, 100);
    }
  });

  // Qikify aktualisiert _syncTags asynchron – polling als Fallback
  let lastTag = '';
  setInterval(() => {
    const current = document.querySelector('input[name="properties[_syncTags]"]')?.value;
    if (current && current !== lastTag) {
      lastTag = current;
      filterGallery();
    }
  }, 300);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBildfilter);
} else {
  initBildfilter();
}


window.filterGallery = filterGallery;
window.initBildfilter = initBildfilter;

